
const lbBrand = {

  red: '#D32F2F',
  redLight: '#E53935',
  redDark: '#B71C1C',
  buttonGradientDark: '#C62828',
  black: '#1a1a1a',
  white: '#FFFFFF',
  offWhite: '#FAFAFA',
  surface: '#F5F5F5',
  border: '#EEEEEE',
  darkGray: '#4B4B4B',
  navGradientTop: '#FFFFFF',
  navGradientBottom: '#FFFFFF',
  // Black carries the header band as a solid fill; every rule inside the white
  // body is a light hairline instead.
  navHeaderBg: '#1a1a1a',
  navInactive: '#2A2A2A',
  navSectionLabel: '#9E9E9E',
  navHover: '#1a1a1a',
  navHoverBg: 'rgba(0, 0, 0, 0.04)',
  navFocusBg: 'rgba(0, 0, 0, 0.06)',
  navOpenBg: 'rgba(0, 0, 0, 0.03)',
  navBorder: '#EAEAEA',
  navDivider: '#EEEEEE',
  headerGradient: 'linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)',
  buttonGradient: 'linear-gradient(135deg, #E53935 0%, #C62828 100%)',
  buttonGradientHover: 'linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%)',
  navGradient: 'linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)',
  authGradient: 'linear-gradient(to right, #1a1a1a 0%, #4B4B4B 100%)',
  buttonShadow: '0 2px 8px rgba(211, 47, 47, 0.3)',
  cardShadow: '0 1px 4px rgba(0, 0, 0, 0.06)',


  success: '#2E7D32',
  error: '#D32F2F',
  danger: '#FF4D4F',
  warning: '#FF9800',
  amber: '#FAAD14',
  neutral: '#E0E0E0',
  neutralText: '#555555',
};

export default lbBrand;
